import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';

import { ProStudioEvents, ProStudioContext } from '../prostudio.xstate.types';

export const deleteBot = async (
  _ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ cb: (() => void) | undefined } | void> => {
  if (event.type !== 'deleteBot') {
    return;
  }

  const { id: draftVersionSolutionId, cb } = event;

  // TODO: check for errors
  if (draftVersionSolutionId) {
    await urqlGql.deleteSolution({
      solutionId: draftVersionSolutionId,
    });
  }

  return {
    cb: draftVersionSolutionId ? cb : undefined,
  };
};
